import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const KEY_PREFIX = "scroll_pos:";

/**
 * 브라우저가 백그라운드 탭을 리로드한 뒤 돌아왔을 때,
 * 사용자가 보던 스크롤 위치로 되돌려 준다.
 * 데이터가 비동기로 로드되어 페이지 높이가 늦게 늘어나는 경우를 대비해
 * 몇 번 재시도하되, 사용자가 직접 스크롤하면 즉시 중단한다.
 */
export default function ScrollRestoration() {
  const location = useLocation();
  const path = location.pathname;

  // 복원
  useEffect(() => {
    let saved: string | null = null;
    try {
      saved = sessionStorage.getItem(KEY_PREFIX + path);
    } catch {
      saved = null;
    }
    if (!saved) return;

    const target = Number(saved);
    if (!target || Number.isNaN(target) || target <= 0) return;

    let cancelled = false;
    const cancel = () => {
      cancelled = true;
    };

    window.addEventListener("wheel", cancel, { passive: true });
    window.addEventListener("touchstart", cancel, { passive: true });
    window.addEventListener("keydown", cancel);

    const restore = () => {
      if (cancelled) return;
      window.scrollTo(0, target);
    };

    const timers = [0, 200, 500, 900].map((delay) => window.setTimeout(restore, delay));

    return () => {
      cancelled = true;
      timers.forEach((t) => window.clearTimeout(t));
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchstart", cancel);
      window.removeEventListener("keydown", cancel);
    };
  }, [path]);

  // 저장 (스크롤 중 과도한 쓰기를 막기 위해 쓰로틀)
  useEffect(() => {
    let timer: number | null = null;

    const onScroll = () => {
      if (timer != null) return;
      timer = window.setTimeout(() => {
        timer = null;
        try {
          sessionStorage.setItem(KEY_PREFIX + path, String(window.scrollY));
        } catch {
          // 저장 실패는 무시
        }
      }, 200);
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (timer != null) window.clearTimeout(timer);
    };
  }, [path]);

  return null;
}